module.exports = __webpack_public_path__ + "img/framework.8ec007ba.jpg";